<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :disableExporting="true"
            :beforeSetupGrid="beforeSetupGrid"
            :actions="actions"
            ref="grid"
        ></dx-grid>
        <!-- <v-dialog persistent v-model="matchDialog" max-width="1000">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Match List</v-card-title
                >
                <v-layout row>
                    <v-layout column xs6>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-150">
                                Person ID
                            </div>
                            <div>{{ clickedPerson.personID }}</div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-150">
                                Name
                            </div>
                            <div>
                                {{
                                    clickedPerson.firstEnglish +
                                        " " +
                                        clickedPerson.lastEnglish
                                }}
                            </div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-150">
                                Hebrew Name
                            </div>
                            <div>
                                {{
                                    clickedPerson.titleHebrew +
                                        " " +
                                        clickedPerson.firstHebrew +
                                        " " +
                                        clickedPerson.lastHebrew +
                                        " " +
                                        clickedPerson.suffixHebrew
                                }}
                            </div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-150">
                                Address
                            </div>
                            <div>
                                {{
                                    clickedPerson.address1 +
                                        " " +
                                        clickedPerson.city +
                                        " " +
                                        clickedPerson.state +
                                        " " +
                                        clickedPerson.zip
                                }}
                            </div>
                        </v-layout>
                    </v-layout>
                    <v-layout column xs6>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-200">
                                Father
                            </div>
                            <div>{{ clickedPerson.father }}</div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-200">
                                Father Address
                            </div>
                            <div>{{ clickedPerson.fatherAddress }}</div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-200">
                                Father In Law
                            </div>
                            <div>{{ clickedPerson.fatherInLaw }}</div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-200">
                                Father In Law Address
                            </div>
                            <div>{{ clickedPerson.fatherInLawAddress }}</div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-200">
                                Account Status
                            </div>
                            <div>{{ clickedPerson.accountStatus }}</div>
                        </v-layout>
                    </v-layout>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">
                        Phone Numbers
                    </div>
                    <div>{{ clickedPerson.phone }}</div>
                </v-layout>
                <v-divider class="mt-3"></v-divider>
                <v-tabs v-model="activeTab" hide-slider>
                    <v-tabs-slider color="success"></v-tabs-slider>
                    <v-tab
                        href="#matches"
                        v-bind:class="{
                            'selected-tab': activeTab == 'matches',
                        }"
                        >MATCHES ({{ matches.length }})</v-tab
                    >
                    <v-tab
                        href="#students"
                        v-bind:class="{
                            'selected-tab': activeTab == 'students',
                        }"
                        >STUDENTS ({{ students.length }})</v-tab
                    >
                    <v-tab
                        href="#notes"
                        v-bind:class="{
                            'selected-tab': activeTab == 'notes',
                        }"
                        >NOTES ({{ getNotes().length }})</v-tab
                    >
                    <v-tab
                        href="#reg-forms"
                        v-bind:class="{
                            'selected-tab': activeTab == 'reg-forms',
                        }"
                        >Registration Forms ({{ regForms.length }})</v-tab
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success"
                        class="mr-1"
                        small
                        @click="openUpdateStatus"
                        >Update Status</v-btn
                    >
                </v-tabs>
                <v-tabs-items v-model="activeTab">
                    <v-tab-item value="matches">
                        <v-btn
                            color="success"
                            class="mr-1"
                            small
                            @click="openAddMatch"
                            >Add Match</v-btn
                        >
                        <v-btn
                            v-if="selectedMatches.length"
                            color="success"
                            small
                            @click="openDeleteMatch"
                            >Delete Matches</v-btn
                        >
                        <v-data-table
                            v-model="selectedMatches"
                            :headers="matchHeaders"
                            :items="matches"
                            item-key="id"
                            class="elevation-0"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <tr
                                    :active="props.selected"
                                    @click="props.selected = !props.selected"
                                >
                                    <td>
                                        <v-checkbox
                                            :input-value="props.selected"
                                            color="success"
                                            primary
                                            hide-details
                                        ></v-checkbox>
                                    </td>
                                    <td>
                                        <a
                                            @click.stop="
                                                openMatchInfo(props.item)
                                            "
                                            class=""
                                            >{{ props.item.doeID }}</a
                                        >
                                    </td>
                                    <td>
                                        {{ props.item.first }}
                                    </td>
                                    <td>
                                        {{ props.item.last }}
                                    </td>
                                    <td>
                                        {{ props.item.address }}
                                    </td>
                                    <td>
                                        {{ props.item.dob | date }}
                                    </td>
                                    <td>
                                        {{ props.item.datE_REG | date }}
                                    </td>
                                    <td>{{ props.item.matchType }}</td>
                                    <td>
                                        <v-icon
                                            class=""
                                            dark
                                            :color="
                                                props.item.verified
                                                    ? 'success'
                                                    : 'danger'
                                            "
                                            >{{
                                                props.item.verified
                                                    ? "mdi-check-circle"
                                                    : "mdi-close"
                                            }}</v-icon
                                        >
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item value="students">
                        <v-data-table
                            v-model="selectedStudents"
                            :headers="studentHeaders"
                            :items="students"
                            item-key="id"
                            class="elevation-0 mt-2"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <tr
                                    :active="props.selected"
                                    @click="props.selected = !props.selected"
                                >
                                    <td>
                                        <a
                                            @click.stop="
                                                openStudentInfo(props.item)
                                            "
                                            class=""
                                            >{{ props.item.id }}</a
                                        >
                                    </td>
                                    <td>
                                        {{ props.item.first }}
                                    </td>
                                    <td>
                                        {{ props.item.last }}
                                    </td>
                                    <td>
                                        {{ props.item.address1 }}
                                    </td>
                                    <td>
                                        {{ props.item.dob | date }}
                                    </td>
                                    <td>
                                        {{ props.item.source }}
                                    </td>
                                    <td>{{ props.item.branch }}</td>
                                    <td>{{ props.item.status }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item value="notes">
                        <notes
                            v-if="clickedPerson.personID"
                            :accountID="clickedPerson.personID"
                            typeID="VOTE_REG"
                            type="VOTE_REG"
                            ref="notes"
                            :isExpanded="true"
                            :hideHeader="true"
                            :showCommunicationType="true"
                        ></notes>
                    </v-tab-item>
                    <v-tab-item value="reg-forms">
                        <v-btn
                            color="success"
                            class="mr-1"
                            small
                            @click="openAddRegistrationForm()"
                            >Add Registration Form</v-btn
                        >
                        <v-data-table
                            :headers="regFormsHeaders"
                            :items="regForms"
                            item-key="id"
                            class="elevation-0 mt-2"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <tr
                                    style="cursor: pointer;"
                                    :active="props.selected"
                                    @click="openAddRegistrationForm(props.item)"
                                >
                                    <td>
                                        {{ props.item.name }}
                                    </td>
                                    <td>
                                        {{ props.item.type }}
                                    </td>
                                    <td>
                                        {{ props.item.address }}
                                    </td>
                                    <td>
                                        {{ props.item.dob | date }}
                                    </td>
                                    <td>
                                        {{ props.item.status }}
                                    </td>
                                    <td>{{ truncate(props.item.note) }}</td>
                                    <td>
                                        {{ props.item.dateSubmitted | date }}
                                    </td>
                                    <td>
                                        {{ props.item.enteredBy }}
                                    </td>
                                    <td>{{ props.item.enteredOn | date }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>

                <v-card-actions class="mr-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeMatchDialog"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog> -->
        <!-- <v-dialog persistent v-model="addMatchDialog" max-width="1700">
            <v-card class="pa-3">
                <v-card-title class="headline pl-2 pt-0 pb-2">
                    Add Match
                </v-card-title>
                <div
                    style="border: #4caf50 2px solid;"
                    class="mb-5"
                    v-if="clickedDOE && clickedDOE.first"
                >
                    <div
                        class="px-2"
                        style="background-color: #4caf50; color: #fff; width: fit-content;"
                    >
                        SELECTED:
                    </div>
                    <div class="pt-2 px-2 pb-1">
                        <v-layout class="mb-2 pl-2">
                            <div class="width-200 font-weight-medium">
                                Name
                            </div>
                            <div>
                                <span class="font-weight-regular mr-2"
                                    >({{
                                        clickedDOE.s == "M" ? "MALE" : "FEMALE"
                                    }})</span
                                >{{ clickedDOE.first + " " + clickedDOE.last }}
                            </div>
                        </v-layout>
                        <v-layout class="mb-2 pl-2">
                            <div class="width-200 font-weight-medium">
                                Address
                            </div>
                            <div>
                                {{
                                    clickedDOE.house +
                                        " " +
                                        clickedDOE.street +
                                        " " +
                                        clickedDOE.apt
                                }}
                            </div>
                        </v-layout>
                        <v-layout class="mb-2 pl-2">
                            <v-select
                                v-model="clickedDOE.matchType"
                                class="my-0 pt-2"
                                style="max-width: 150px;"
                                label="Match Type"
                                :items="['Husband', 'Wife', 'Daughter', 'Son']"
                                hide-details
                            >
                            </v-select>
                        </v-layout>
                    </div>
                </div>

                <div v-if="showDoeGrid">
                    <data-grid
                        class="simple-datagrid pr-0 doe-table"
                        :url="doeUrl"
                        :dontSaveFilters="true"
                        :hideHeader="true"
                        :perPage="6"
                        :columns="doeColumns"
                        title="DOE"
                        ref="doeGrid"
                        :beforeSetupGrid="beforeSetupDoeGrid"
                        navigationPath="onSearchDOERowClicked"
                        navigationField="onSearchDOERowClicked"
                        v-bind:hideActions="true"
                        :onRowClicked="onSearchDOERowClicked"
                        :sortOptions="{
                            enabled: true,
                            field: 'last',
                            type: 'asc',
                        }"
                    ></data-grid>
                </div>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeAddMatchDialog"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveMatch()"
                        >Add Match</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="existingMatchesWarningDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline text-warning pl-0 pt-0">
                    Are you sure?
                </v-card-title>
                <div class="mb-3">
                    This person is already matched, Do you want to continue?
                </div>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="existingMatchesWarningDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="addMatch()">Continue</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteMatchDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0">
                    Are you sure?
                </v-card-title>
                <div class="mb-3">This will delete the selected matches</div>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteMatchDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="deleteMatches()"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="matchInfoDialog" max-width="1000">
            <v-card v-if="clickedMatchDoe" class="pa-3">
                <doe-match-info
                    :row="clickedMatchDoe"
                    :columns="doeColumns"
                ></doe-match-info>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="matchInfoDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="infoDialog" max-width="1000">
            <v-card v-if="clickedDOE" class="pa-3">
                <doe-match-info
                    :row="clickedDOE"
                    :columns="doeColumns"
                ></doe-match-info>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="infoDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateStatusDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pt-0 pb-2 pl-0">
                    Update Status
                </v-card-title>
                <v-select
                    :items="accountStatuses"
                    v-model="accountStatus"
                    label="Account Status"
                    clearable
                ></v-select>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateStatusDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="saveAccountStatus()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="addRegFormDialog" max-width="400">
            <voting-reg-form
                ref="regFormDialog"
                :form="clickedRegForm"
                :person="clickedPerson"
                :reload="loadRegForms"
                :close="closeAddRegistrationForm"
            ></voting-reg-form>
        </v-dialog> -->

        <v-dialog persistent v-model="matchDialog" max-width="1000">
            <voting-master-list-person
                :person="clickedPerson"
                :reload="reload"
                :close="closeMatchDialog"
            ></voting-master-list-person>
        </v-dialog>
    </div>
</template>

<script>
import { truncate } from "../../utils/helpers.js";
import DoeMatchInfo from "./DoeMatchInfo.vue";
import votingRegForm from "./VotingRegForm.vue";
import notes from "../components/Notes.vue";
import votingMasterListPerson from "./VotingMasterListPerson.vue";

export default {
    components: {
        DoeMatchInfo,
        votingRegForm,
        notes,
        votingMasterListPerson,
    },
    data: () => ({
        title: "Master List",
        matchDialog: false,
        deleteMatchDialog: false,
        addMatchDialog: false,
        infoDialog: false,
        matchInfoDialog: false,
        existingMatchesWarningDialog: false,
        clickedPerson: {},
        clickedDOE: {},
        clickedMatchDoe: {},
        selectedMatches: [],
        matches: [],
        students: [],
        selectedStudents: [],
        userID: "",
        processing: false,
        showDoeGrid: false,
        url: "",
        doeUrl: "doe",
        actions: [],
        phoneSearch: "",
        activeTab: "matches",

        updateStatusDialog: false,
        accountStatus: "",
        accountStatuses: [
            "Registered",
            "Don’t Want To Registrar",
            "Waiting For Application",
            "Received Application ",
        ],

        regForms: [],
        addRegFormDialog: false,
        clickedRegForm: {},

        rules: {
            required: (value) => !!value || "Required.",
        },

        matchHeaders: [
            {
                text: "",
                value: "",
            },
            {
                text: "DOE ID",
                value: "doeID",
            },
            { text: "First", value: "first" },
            { text: "Last", value: "last" },
            { text: "Address", value: "address" },
            { text: "DOB", value: "dob" },
            { text: "Registered On", value: "datE_REG" },
            { text: "Match Type", value: "matchType" },
            { text: "Verified", value: "verified" },
        ],

        doeColumns: [
            {
                field: "isMatched",
                isIcon: true,
                icon: (value) => {
                    return value ? "mdi-check-circle" : "mdi-alert";
                },
                iconColor: (value) => {
                    return value ? "success" : "#f35123";
                },
            },
            {
                label: "ID",
                field: "reG_ID",
                sortable: true,
                hidden: false,
                showLink() {
                    return true;
                },
                filterOptions: {
                    enabled: true,
                    filterValue: "",
                    placeholder: "",
                },
            },
            {
                label: "First",
                field: "first",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterValue: "",
                    placeholder: "",
                },
            },
            {
                label: "Last",
                field: "last",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterValue: "",
                    placeholder: "",
                },
            },
            {
                label: "Gander",
                field: "s",
                sortable: true,
                width: "50px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            {
                label: "House",
                field: "house",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterValue: "",
                    placeholder: "",
                },
            },
            {
                label: "Street",
                field: "street",
                sortable: true,
                width: "250px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterValue: "",
                    placeholder: "",
                },
            },
            {
                label: "Apt",
                field: "apt",
                sortable: true,
                width: "50px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            {
                label: "City",
                field: "city",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            {
                label: "Zip",
                field: "zip",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            {
                sortable: true,
                label: "Matched",
                field: "isMatched",
                type: "boolean",
                formatFn: (value, row) => {
                    return row.isMatched ? "Yes" : "No";
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Select",
                    filterDropdownItems: [
                        { value: true, text: "Yes" },
                        { value: false, text: "No" },
                    ],
                },
            },
            {
                label: "Matched To",
                field: "matchName",
                width: "250px",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            {
                label: "DOB",
                field: "dob",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            // {
            //     label: "Registered On",
            //     field: "datE_REG",
            //     sortable: true,
            //     hidden: false,
            //     filterOptions: {
            //         enabled: true,
            //         placeholder: "",
            //     },
            // },
        ],

        columns: [
            {
                field: "titleHebrew",
                label: "Title Hebrew",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "firstHebrew",
                label: "First Hebrew",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastHebrew",
                label: "Last Hebrew",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "firstEnglish",
                label: "First English",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastEnglish",
                label: "Last English",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "personID",
                label: "Person ID",
                //link: "DinnerAccountView",
                format: "",
                //template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "address1",
                label: "Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "city",
                label: "City",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "state",
                label: "State",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "zip",
                label: "Zip",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "matchCount",
                label: "Match Count",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "studentCount",
                label: "Student Count",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "regFormsCount",
                label: "Registration Forms Count",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountStatus",
                label: "Account Status",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "phone",
                label: "Phone",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        studentHeaders: [
            // { text: "", value: "" },
            { text: "ID", value: "id" },
            { text: "First", value: "first" },
            { text: "Last", value: "last" },
            { text: "Address", value: "address1" },
            { text: "DOB", value: "dob" },
            { text: "Source", value: "source" },
            { text: "Branch", value: "branch" },
            { text: "Status", value: "status" },
        ],

        regFormsHeaders: [
            // { text: "ID", value: "id" },
            { text: "Name", value: "name" },
            { text: "Type", value: "type" },
            { text: "Address", value: "address" },
            { text: "DOB", value: "dob" },
            { text: "Status", value: "status" },
            { text: "Note", value: "note" },
            { text: "Date Submitted", value: "dateSubmitted" },
            { text: "Entered By", value: "enteredBy" },
            { text: "Entered On", value: "enteredOn" },
        ],
    }),
    created() {},
    methods: {
        beforeSetupGrid() {
            this.actions.push({
                text: "Phone Number",
                type: "input",
                inputType: "number",
                mask: "###-###-####",
                align: "left",
                value: this.phoneSearch,
                onChanged: this.onPhoneNumberSearch,
                clearable: true,
            });

            this.url = "voting?phoneNumber=";
        },
        // async loadUserID() {
        //     this.userID = await this.$http.get(
        //         "api/users/getUserID?username=" +
        //             this.$store.state.authentication.user
        //     );
        // },
        onPhoneNumberSfearch(value) {
            this.phoneSearch = value ? value.replaceAll("-", "") : "";

            this.url =
                "voting?" +
                (this.phoneSearch
                    ? "phoneNumber=" + this.phoneSearch
                    : "phoneNumber=");

            this.$refs.grid.reloadDataSource(this.url);
        },
        async onRowClicked(row) {
            //this.activeTab = "matches";
            this.selectedMatches = [];
            this.clickedPerson = row;

            // await this.loadMatches(row.personID);

            // const parents = await this.$http.post("api/voting/getParents", [
            //     row.paternalGrandParentId,
            //     row.maternalGrandParentId,
            // ]);

            // const students = await this.$http.get(
            //     "api/voting/GetStudents?personID=" + row.personID,
            // );

            // const father = parents.find(
            //     (p) => p.personID == row.paternalGrandParentId,
            // );
            // const fatherInLaw = parents.find(
            //     (p) => p.personID == row.maternalGrandParentId,
            // );

            // this.students = students;
            // this.clickedPerson.fatherAddress = father ? father.address1 : "";
            // this.clickedPerson.fatherInLawAddress = fatherInLaw
            //     ? fatherInLaw.address1
            //     : "";

            this.matchDialog = true;

            // const regForms = await this.$http.get(
            //     "api/votingRegstrationFormStatus/getByID?personID=" +
            //         row.personID,
            // );

            // this.regForms = regForms;
        },
        async loadMatches(personID) {
            const matches = await this.$http.get(
                "api/voting/getMatches?personID=" +
                    encodeURIComponent(personID),
            );

            this.matches = matches
                .filter((m) => !m.removed)
                .map((match) => {
                    match.address = match.house + " " + match.street;

                    return match;
                });
        },
        getNotes() {
            if (!this.$refs || !this.$refs.notes) return [];

            return this.$refs.notes.getNotes();
        },
        openDeleteMatch() {
            this.deleteMatchDialog = true;
        },
        openAddMatch() {
            this.addMatchDialog = true;
            this.showDoeGrid = true;
        },
        openAddRegistrationForm(row = null) {
            this.clickedRegForm = row ? row : {};
            this.addRegFormDialog = true;

            if (this.$refs.regFormDialog) {
                this.$refs.regFormDialog.resetValidation();
            }
        },
        closeAddRegistrationForm() {
            this.addRegFormDialog = false;
        },
        async loadRegForms() {
            this.regForms = await this.$http.get(
                "api/votingRegstrationFormStatus/getByID?personID=" +
                    this.clickedPerson.personID,
            );
        },
        closeMatchDialog() {
            this.matchDialog = false;
        },
        reload() {
            this.$refs.grid.reloadGrid();
        },
        async openMatchInfo(row) {
            this.clickedMatchDoe = await this.$http.get(
                "api/voting/getDoe?id=" + row.doeID,
            );
            this.matchInfoDialog = true;
        },
        openUpdateStatus() {
            this.accountStatus = this.clickedPerson.accountStatus;
            this.updateStatusDialog = true;
        },
        async saveAccountStatus() {
            //if (!this.$refs.accountStatus.validate(true)) return;

            try {
                this.processing = true;

                await this.$http.post("api/voting/saveAccountSettings", {
                    personID: this.clickedPerson.personID,
                    accountStatus: this.accountStatus,
                });

                this.clickedPerson.accountStatus = this.accountStatus;
                this.updateStatusDialog = false;
                this.$refs.grid.reloadGrid();
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        truncate(text) {
            return truncate(text, 35);
        },
        openStudentInfo(row) {},
        beforeSetupDoeGrid() {
            this.doeColumns.find(
                (c) => c.field == "reG_ID",
            ).linkAction = this.openInfoDialog;

            this.doeColumns.find(
                (c) => c.field == "last",
            ).filterOptions.filterValue = this.clickedPerson.lastEnglish.slice(
                0,
                4,
            );

            const houseNumber = this.clickedPerson.address1.split(" ")[0];
            const street = this.clickedPerson.address1.split(" ")[1];

            this.doeColumns.find(
                (c) => c.field == "house",
            ).filterOptions.filterValue = houseNumber
                ? houseNumber.slice(0, 4)
                : "";
            this.doeColumns.find(
                (c) => c.field == "street",
            ).filterOptions.filterValue = street ? street.slice(0, 4) : "";

            this.doeUrl = "doe";
        },
        closeAddMatchDialog() {
            this.doeColumns.find(
                (c) => c.field == "first",
            ).filterOptions.filterValue = "";
            this.doeColumns.find(
                (c) => c.field == "last",
            ).filterOptions.filterValue = "";
            this.doeColumns.find(
                (c) => c.field == "house",
            ).filterOptions.filterValue = "";
            this.doeColumns.find(
                (c) => c.field == "street",
            ).filterOptions.filterValue = "";

            this.showDoeGrid = false;
            this.addMatchDialog = false;
        },
        openInfoDialog(row) {
            this.clickedDOE = row;
            this.infoDialog = true;
        },
        async deleteMatches() {
            try {
                this.processing = true;

                await this.$http.post("api/voting/RemoveMatches", {
                    userID: this.$store.state.authentication.user,
                    ids: this.selectedMatches.map((m) => m.id),
                });

                this.$notify({
                    text: "Matches Deleted",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;
                this.loadMatches(this.clickedPerson.personID);
                this.deleteMatchDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async saveMatch() {
            if (!this.clickedDOE || !this.clickedDOE.regID) {
                return this.$notify({
                    text: "Please select person",
                    group: "notification",
                    type: "error",
                });
            }
            if (!this.clickedDOE.matchType) {
                return this.$notify({
                    text: "Please select Match Type",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const existingMatches = await this.$http.get(
                    "api/voting/GetMatchByDoeID?doeID=" + this.clickedDOE.regID,
                );

                if (existingMatches && existingMatches.length) {
                    this.processing = false;

                    this.existingMatchesWarningDialog = true;

                    return;
                }

                await this.addMatch();
            } catch (e) {
                this.processing = false;
            }
        },
        async addMatch() {
            try {
                this.processing = true;

                await this.$http.post("api/voting/addMatch", {
                    doeID: this.clickedDOE.regID,
                    personID: this.clickedPerson.personID,
                    verified: this.clickedDOE.verified ? 2 : 0,
                    matchType: this.clickedDOE.matchType,
                    matchedByUserID: this.$store.state.authentication.user,
                    verifiedByUserID: this.$store.state.authentication.user,
                    phoneMatch: this.clickedDOE.phoneMatch ? 1 : null,
                    addressMatch: this.clickedDOE.addressMatch ? 1 : null,
                });

                this.$notify({
                    text: "Match Saved",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;
                this.loadMatches(this.clickedPerson.personID);
                this.closeAddMatchDialog();
                this.existingMatchesWarningDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        onSearchDOERowClicked(row) {
            this.clickedDOE = row;
            this.clickedDOE.matchType =
                this.clickedDOE.s == "M"
                    ? "Husband"
                    : this.clickedDOE.s == "F"
                    ? "Wife"
                    : "";
            this.clickedDOE.verified = true;
            this.clickedDOE.phoneMatch = false;
            this.clickedDOE.addressMatch = false;
        },
    },
};
</script>
<style>
.accounts-search.container {
    padding-top: 0px;
}
.doe-table .vgt-table th {
    padding: 0.2em 1.5em 0em 0.75em !important;
}
.doe-table table.vgt-table td {
    padding: 0.5em 0.75em 0.5em 0.75em !important;
}
.doe-table .table.vgt-table {
    font-size: 14px !important;
}
.doe-table .vgt-table th.filter-th {
    padding: 0.2em 0.75em 0.5em 0.75em !important;
}
.selected-tab {
    color: rgb(76, 175, 80) !important;
    border-bottom: 1px solid rgb(76, 175, 80) !important;
}
</style>
